<template>
<div>
    <regstep :step="3"></regstep>
     <div class="md regauto">
        <div class="regbox">
            <div class="base-info">最后一步啦~请填写您公司HR的基本信息。</div>
            <div class="reg-item clearfix">
                <div class="reg-txt" style="float:left;margin-top:34px;">头像：</div>
                <div class="hrface-chaun">
                    <input type="file" @change="faceChange" class="hrface-file">
                     <img class="logoimg" v-if="!headImage"  src="../../assets/images/logochuan.png">
                    <img class="logoimg" v-else :src="headImage">
                </div>
            </div>
            <div class="reg-item">
                <div class="reg-txt">姓名：</div>
                <div class="reg-ms">
                    <input type="text" v-model="name" class="reg-inp" placeholder="请输入HR的姓名">
                </div>
            </div>
            <button style="margin-top:30px;" class="btn-primary" @click="gostep">下一步</button>
        </div>
    </div>
</div>
</template>
<script>
const qs = require('qs');
import Regstepimg from '../../components/Regstepimg'
export default {
    data(){
        return {
            headImage:'', // 头像地址
            name:''
        }
    },
    components:{
        regstep:Regstepimg
    },
    methods:{
        faceChange(event){
            let formdata = new FormData();
            formdata.append('headImageFile',event.target.files[0]);
            this.axios.post('/wapi/base/upload/headImage',formdata)
            .then(res =>{
                if(res.status*1 == 200){
                    this.headImage = res.data;
                }
            })
        },
        gostep(){
            let url = '/wapi/hr/modifyInfo';
            if(this.headImage.length == 0){
                this.$message({
                    message:'请上传头像',
                    type:'warning'
                })
                return;
            }
            if(this.name.length == 0){
                this.$message({
                    message:'请输入hr昵称',
                    type:'warning'
                })
                return;
            }
            let qdata = {
                nickName:this.name,
                headImage:this.headImage
            };

            this.axios.post(url,qs.stringify(qdata))
            .then(res => {
                if(res.status*1 == 200){
                    this.$router.push({path:"/register/regsuc"})
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.hrface-chaun{
    position:relative;
    width:98px;
    height:98px;
    border-radius:50%;
    float:left;
    margin-left:30px;
    overflow:hidden;
    cursor:pointer;
    img{
        width:98px;
        height:98px;
        border-radius:50%;
        position:absolute;
        top:0;
        left:0;
    }
    .hrface-file{
        position:absolute;
        top:0;
        left:0;
        width:98px;
        font-size:50px;
        opacity:0;
        z-index:2;
        cursor:pointer;
    }
}
</style>



// WEBPACK FOOTER //
// hrinfo.vue?11b9062d